import { createContext, useContext, useState } from 'react';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);
export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [open, setOpen] = useState(false);
  const show = true;

  const addToCart = (item) => {
    setCart((prev) => {
      if (item.type === 'plan') {
        return [item];
      }
      if (prev.some((c) => c.type === 'plan')) {
        return prev;
      }
      if (prev.find((c) => c.courseId === item.courseId)) return prev;
      return [...prev, item];
    });
  };

  const removeFromCart = (courseId) => {
    setCart((prev) => prev.filter((c) => c.courseId !== courseId));
  };

  const clearCart = () => setCart([]);

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, clearCart, open, show, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
